import { render, staticRenderFns } from "./CopingLiving.vue?vue&type=template&id=50aba1c0&scoped=true"
import script from "./CopingLiving.vue?vue&type=script&lang=js"
export * from "./CopingLiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aba1c0",
  null
  
)

export default component.exports